import React from 'react';
import { updatedata } from '../../util/global';
import { deliveryitem, deliverypartneritem } from './Datatype';

const failurereasons = [
  'customer not available',
  'customer requested change',
  'wrong / incomplete address',
  'access issue (gate / security)',
  'stock unavailable',
  'vehicle / staff issue',
  'other'
];

interface props {
  showmodal: string;
  setshowmodal: (modal: string) => void;
  formdata: deliveryitem;
  setformdata: (data: deliveryitem) => void;
  fetchdata: () => void;
  partners: deliverypartneritem[];
}

const AdminDeliveryForm: React.FC<props> = ({
  showmodal,
  setshowmodal,
  formdata,
  setformdata,
  fetchdata,
  partners
}) => {
  if (showmodal !== "showdeliveryform") return null;

  // a failed delivery needs a reason, and 'other' needs the notes to say what happened
  const cansave = !(formdata.status === 'failed' && !formdata.reason) && !(formdata.reason === 'other' && !formdata.notes);

  const handlesave = async () => {
    const reason = formdata.status === 'failed' ? formdata.reason : '';
    // one call: the delivery update plus a new status log row
    const payload = {
      dataset: [
        {
          _id: formdata._id,
          status: formdata.status,
          reason,
          notes: formdata.notes,
          _deliverypartnerid: formdata._deliverypartnerid,
          deliveryagent: formdata.deliveryagent,
          datatype: 'deliverydata'
        },
        {
          _deliveryid: formdata._id,
          status: formdata.status,
          reason,
          notes: formdata.notes,
          _deliverypartnerid: formdata._deliverypartnerid,
          deliveryagent: formdata.deliveryagent,
          datatype: 'deliverystatusdata'
        }
      ]
    };
    await updatedata(payload);
    setshowmodal("");
    fetchdata();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>edit delivery</h3>
          <button className="close-btn" onClick={() => setshowmodal("")}>&times;</button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label>delivery date</label>
            <div>{formdata.deliverydate}</div>
          </div>

          <div className="form-group">
            <label>customer</label>
            <div>{formdata.customername}</div>
          </div>

          <div className="form-group">
            <label>address</label>
            <div>{formdata.address}</div>
          </div>

          <div className="form-group">
            <label>items</label>
            {formdata.items?.map((it: any, idx: number) => (
              <div key={idx}>{it.quantity} x {it.name || it.productid}</div>
            ))}
          </div>

          <div className="form-group">
            <label>status</label>
            <select
              className="form-input"
              value={formdata.status || 'scheduled'}
              onChange={(e) => setformdata({ ...formdata, status: e.target.value })}
            >
              <option value="scheduled">scheduled</option>
              <option value="out-for-delivery">out-for-delivery</option>
              <option value="delivered">delivered</option>
              <option value="failed">failed</option>
            </select>
          </div>

          {formdata.status === 'failed' && (
            <div className="form-group">
              <label>reason</label>
              <select
                className="form-input"
                value={formdata.reason || ''}
                onChange={(e) => setformdata({ ...formdata, reason: e.target.value })}
              >
                <option value="">select reason</option>
                {failurereasons.map((r) => (
                  <option key={r} value={r}>{r}</option>
                ))}
              </select>
            </div>
          )}

          <div className="form-group">
            <label>notes</label>
            <textarea
              className="form-input"
              value={formdata.notes || ''}
              onChange={(e) => setformdata({ ...formdata, notes: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>delivery partner</label>
            <select
              className="form-input"
              value={formdata._deliverypartnerid || ''}
              onChange={(e) => setformdata({ ...formdata, _deliverypartnerid: e.target.value })}
            >
              <option value="">select partner</option>
              {partners.map((p) => (
                <option key={p._id} value={p._id || ''}>{p.name}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>delivery person name</label>
            <input
              type="text"
              className="form-input"
              value={formdata.deliveryagent.name || ''}
              onChange={(e) => setformdata({ ...formdata, deliveryagent: { ...formdata.deliveryagent, name: e.target.value } })}
            />
          </div>

          <div className="form-group">
            <label>delivery person phone</label>
            <input
              type="text"
              className="form-input"
              value={formdata.deliveryagent.phone || ''}
              onChange={(e) => setformdata({ ...formdata, deliveryagent: { ...formdata.deliveryagent, phone: e.target.value } })}
            />
          </div>

          <button className="btn-blue full-width" onClick={handlesave} disabled={!cansave}>
            save delivery
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminDeliveryForm;
